@if (visible) {
  <div class="bu-modal__overlay">
    <div class="bu-modal" role="dialog" aria-modal="true"
         aria-labelledby="bu-modal-title" aria-describedby="bu-modal-intro"
         cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.escape)="close()">
      <div class="bu-modal__head">
        <div>
          <div class="bu-modal__sub">{{ 'benchBu.subtitle' | translate }}</div>
          <div class="bu-modal__title" id="bu-modal-title">{{ 'benchBu.title' | translate }}</div>
        </div>
        <button class="bu-modal__x" type="button" [attr.aria-label]="'general.close' | translate" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="bu-modal__body">
        <p class="bu-modal__intro" id="bu-modal-intro">{{ 'benchBu.intro' | translate }}</p>

        <div class="bu-modal__list-head">
          <span class="bu-modal__count">{{ 'benchBu.summary' | translate: {count: totalCount, active: activeCount} }}</span>
          <button class="bu-modal__add" type="button" (click)="addBu()">
            <mat-icon>add</mat-icon>{{ 'benchBu.add' | translate }}
          </button>
        </div>

        <div class="bu-modal__grid-head">
          <span>{{ 'benchBu.col.key' | translate }}</span>
          <span>{{ 'benchBu.col.name' | translate }}</span>
          <span>{{ 'benchBu.col.usage' | translate }}</span>
          <span>{{ 'benchBu.col.color' | translate }}</span>
          <span>{{ 'benchBu.col.status' | translate }}</span>
          <span></span>
        </div>

        @for (b of catalog; track b.id || $index) {
          <div class="bu-modal__row" [class.bu-modal__row--inactive]="!b.active">
            <input class="bu-modal__input bu-modal__key" type="text" maxlength="4"
                   [ngModel]="b.key" (ngModelChange)="onKeyInput(b, $event)"
                   (blur)="persistUpdate(b)"
                   [attr.aria-label]="'benchBu.col.key' | translate">
            <input class="bu-modal__input" type="text"
                   [(ngModel)]="b.name"
                   (blur)="persistUpdate(b)"
                   [placeholder]="'benchBu.namePlaceholder' | translate"
                   [attr.aria-label]="'benchBu.col.name' | translate">
            <span class="bu-modal__usage">
              @if (b.usageCount > 0) {
                {{ 'benchBu.usage' | translate: {count: b.usageCount} }}
              } @else {
                <span class="bu-modal__usage-empty">—</span>
              }
            </span>
            <input class="bu-modal__color" type="color" [(ngModel)]="b.color"
                   (change)="persistUpdate(b)"
                   [attr.aria-label]="'benchBu.col.color' | translate">
            <button class="bu-modal__toggle" type="button"
                    role="switch" [attr.aria-checked]="b.active"
                    [class.bu-modal__toggle--on]="b.active"
                    [disabled]="b.isDraft || isSaving(b)"
                    (click)="onToggleClick(b)">
              <span class="bu-modal__toggle-knob"></span>
              <span class="bu-modal__toggle-label">
                {{ (b.active ? 'benchBu.statusActive' : 'benchBu.statusInactive') | translate }}
              </span>
            </button>
            <button class="bu-modal__del" type="button"
                    [attr.aria-label]="'benchBu.remove' | translate"
                    [title]="'benchBu.remove' | translate"
                    (click)="removeBu(b)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        } @empty {
          @if (!isLoading) {
            <div class="bu-modal__empty">{{ 'benchBu.empty' | translate }}</div>
          }
        }
      </div>

      <div class="bu-modal__foot">
        <span class="bu-modal__hint">{{ 'benchBu.hint' | translate }}</span>
        <div class="bu-modal__actions">
          <button class="bu-modal__btn-primary" type="button" (click)="close()">
            {{ 'benchBu.done' | translate }}
          </button>
        </div>
      </div>

      @if (pendingToggle) {
        <div class="bu-modal__confirm-overlay" (click)="cancelPendingToggle()">
          <div class="bu-modal__confirm" role="dialog" aria-modal="true"
               aria-labelledby="bu-confirm-title"
               (click)="$event.stopPropagation()"
               (keydown.escape)="cancelPendingToggle()">
            <div class="bu-modal__confirm-title" id="bu-confirm-title">
              <mat-icon>warning</mat-icon>{{ 'benchBu.deactivate.title' | translate }}
            </div>
            <p class="bu-modal__confirm-text">
              {{ 'benchBu.deactivate.text' | translate: {key: pendingToggle.row.key, name: pendingToggle.row.name,
                 count: pendingUsageCount,
                 offerWord: (pendingUsageCount === 1 ? 'benchBu.deactivate.singular' : 'benchBu.deactivate.plural') | translate} }}
            </p>
            <label class="bu-modal__confirm-field">
              <span>{{ 'benchBu.deactivate.target' | translate }}</span>
              @if (migrationTargets().length) {
                <select class="bu-modal__input" [(ngModel)]="pendingToggle.target">
                  @for (t of migrationTargets(); track t.id) {
                    <option [value]="t.id">{{ t.key }} — {{ t.name }}</option>
                  }
                </select>
              } @else {
                <span class="bu-modal__confirm-nonavailable">
                  {{ 'benchBu.deactivate.noneAvailable' | translate }}
                </span>
              }
            </label>
            <div class="bu-modal__confirm-actions">
              <button class="bu-modal__btn-secondary" type="button" (click)="cancelPendingToggle()">
                {{ 'general.cancel' | translate }}
              </button>
              <button class="bu-modal__btn-primary" type="button"
                      [disabled]="!pendingToggle.target"
                      (click)="confirmPendingToggle()">
                {{ 'benchBu.deactivate.confirm' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
